import React, { useEffect, useState } from "react";
import "./summaryTable.css";
import "./filterStyles.css";
import LaddaButton from "../../components/buttons/laddaButton";
import { icons } from "../../constants";
import BreadCrumbComp from "../../components/breadCrumb";
import SimpleTable from "../../components/tables/simpleTable";
import { getModeText } from "../../utils/burnData";
import { useForm } from "react-hook-form";
import { Grid, useMediaQuery } from "@mui/material";
import SimpleSelect from "../../components/selects/simpleSelect";
import MultiSelect from "../../components/selects/multiSelect";
import FormTextField from "../../components/textField/formTextField";
import { getCookie } from "../../utils/getCookie";
import InventaryDownload from "./modals/inventaryDownload";
import DeviceDetails from "./modals/deviceDetails";
import { Link, useNavigate } from "react-router-dom";
import EditDevice from "./modals/editDevice";
import { useDispatch, useSelector } from "react-redux";
import {
  resetBiomedicalId,
  resetEquipementSerieId,
  setBiomedicalId,
  setEquipementSerieId
} from "../../redux/slices/biomedicalSlice";
import {
  biomedicalManagementGetLastUpdate,
  callApiAsync,
  getDevicesInventoryFilters,
  getDevicesInventoryPaged,
  getDevicesInventoryNotificationsApprover,
  getDevicesInventoryNotificationsbyUser,
  getSelectsBiomedical
} from "../../services/apiService";
import MenuButton from "../../components/menuButton";
import ModalComponent from "../../components/modals";
import { hasAnyRoleUtil } from "../../utils/AuthorizedUtils/360Report";
import {
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_INSPECTION_APPROVE_ROLES,
  BIOMEDICAL_INSPECTION_EDIT_ROLES,
  BIOMEDICAL_INVENTORY_DOWNLOAD_ROLES,
  BIOMEDICAL_INVENTORY_EDIT_ROLES,
  BIOMEDICAL_INVENTORY_IMPORT_ROLES
} from "../../constants/biomedicalRoles";
import { inspectionRecordProcess } from "../../constants/enums";
import { usefulLifeStatusOptions } from "../../constants/selectData";
import {
  formatCustomDate,
  formatCustomDateWithHour
} from "../../services/dateService";
import { StyledTooltip } from "../../components/toolltipComponent";
import {
  getRestUsefulLife,
  getUsefulLifeBaseDate,
  getUsefulLifeStatus
} from "../../utils/biomedicalEquipmentUtils";
import { useBiomedicalFilters } from "../../context/BiomedicalFiltersContext";
import MassiveUploadModal from "./modals/massiveUploadModal";
import { useLoadingState } from "../../components/loadingFeedback";

const FILTER_DEFAULTS = {
  equipment: "",
  serieNumber: "",
  model: [],
  mode: [],
  institution: [],
  ubication: [],
  brand: "",
  usefulLifeStatus: ""
};

const ManageDevice = () => {
  const [loadingTable, setLoadingTable] = useLoadingState(true);
  const dispatch = useDispatch();
  const userSesion = getCookie("sesion");
  const userId = userSesion.id_usuario;
  const userData = useSelector((state) => state.userData.userData);
  const { filters, setFilters, clearFilters } = useBiomedicalFilters();
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [inventaryDownloadModal, setInventaryDownloadModal] = useState(false);
  const [editDeviceModal, setEditDeviceModal] = useState(false);
  const [notificationDataModal, setNotificationDataModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [modelFilter, setModelFilter] = useState([]);
  const [institution, setInstitution] = useState([]);
  const [producerFilter, setProducerFilter] = useState([]);
  const [brandFilter, setBrandFilter] = useState([]);
  const [stateFilter, setStateFilter] = useState([]);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
  const [technologyModalityOptions, setTechnologyModalityOptions] = useState(
    []
  );
  const [openMasive, setOpenMasive] = useState(false);
  const [ubicationFilter, setUbicationFilter] = useState([]);
  const [bioEquipmentIdState, setBioEquipmentIdState] = useState(null);
  const [notification, setNotification] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const {
    control: controlTable,
    getValues: getValuesTable,
    reset
  } = useForm({
    defaultValues:
      filters && Object.keys(filters).length > 0 ? filters : FILTER_DEFAULTS
  });

  const { control: notificationControl, setValue: notificationSetValue } =
    useForm({
      defaultValues: {
        coment: ""
      }
    });

  dispatch(resetEquipementSerieId());
  dispatch(resetBiomedicalId());

  const navigate = useNavigate();

  const normalizeFilters = (rawFilters = {}) => {
    const normalized = { ...FILTER_DEFAULTS, ...rawFilters };

    return {
      equipment: String(normalized.equipment || "").trim(),
      serieNumber: String(normalized.serieNumber || "").trim(),
      model: Array.isArray(normalized.model) ? normalized.model : [],
      mode: Array.isArray(normalized.mode) ? normalized.mode : [],
      institution: Array.isArray(normalized.institution)
        ? normalized.institution
        : [],
      ubication: Array.isArray(normalized.ubication)
        ? normalized.ubication
        : [],
      brand: normalized.brand ?? "",
      usefulLifeStatus: normalized.usefulLifeStatus || ""
    };
  };

  const buildServerFilters = (rawFilters = {}) => {
    const normalized = normalizeFilters(rawFilters);

    return Object.fromEntries(
      Object.entries(normalized)
        .map(([key, value]) => [
          key,
          Array.isArray(value) ? value.join(",") : value
        ])
        .filter(([, value]) => value !== "" && value != null)
    );
  };

  const getDevicesInventory = async (
    page = currentPage,
    pageSize = rowsPerPage,
    filtersToApply = filters
  ) => {
    setLoadingTable(true);
    try {
      const response = await getDevicesInventoryPaged(
        userId,
        page,
        pageSize,
        buildServerFilters(filtersToApply)
      );
      const data = response?.data?.data || [];
      const duplicates = response?.data?.meta?.duplicates;

      if (duplicates?.detected) {
        console.warn(
          "Se detectaron equipos biomédicos duplicados en la respuesta paginada:",
          duplicates
        );
      }

      setFilteredDevices(data);
      setCurrentPage(response?.data?.page || page);
      setRowsPerPage(response?.data?.pageSize || pageSize);
      setTotalRecords(response?.data?.total || 0);
    } catch (error) {
      console.error("Error fetching devices:", error);
    } finally {
      setLoadingTable(false);
    }
  };

  const getFilters = () => {
    callApiAsync(
      () => getDevicesInventoryFilters(userId),
      (data) => {
        setInstitution(data?.institutionFilter);
        setModelFilter(data?.modelFilter);
        setProducerFilter(data?.producerFilter);
        setBrandFilter(data?.brandFilter);
        setUbicationFilter(data?.ubicationFilter);
      }
    );
  };

  const getModalityOptions = () => {
    callApiAsync(
      () => getSelectsBiomedical(),
      (data) => {
        setTechnologyModalityOptions(data?.state || []);
      }
    );
  };

  const canApproveInspection = hasAnyRoleUtil(
    BIOMEDICAL_INSPECTION_APPROVE_ROLES,
    userData.roleList
  );
  const canEditInspection = hasAnyRoleUtil(
    BIOMEDICAL_INSPECTION_EDIT_ROLES,
    userData.roleList
  );
  const canEditInventory = hasAnyRoleUtil(
    BIOMEDICAL_INVENTORY_EDIT_ROLES,
    userData.roleList
  );
  const canAccessBiomedicalAdmin = hasAnyRoleUtil(
    [BIOMEDICAL_MODULE_ADMIN],
    userData.roleList
  );
  const canDownloadInventory = hasAnyRoleUtil(
    BIOMEDICAL_INVENTORY_DOWNLOAD_ROLES,
    userData.roleList
  );
  const canImportInventory = hasAnyRoleUtil(
    BIOMEDICAL_INVENTORY_IMPORT_ROLES,
    userData.roleList
  );

  const getNotification = () => {
    if (canApproveInspection) {
      callApiAsync(
        () => getDevicesInventoryNotificationsApprover(userId),
        (data) => {
          const filteredData = data.filter((item) => {
            if (canApproveInspection) {
              if (canEditInspection) {
                return (
                  item.state === inspectionRecordProcess.sent ||
                  item.state === inspectionRecordProcess.pending
                );
              }
              return item.state === inspectionRecordProcess.sent;
            } else {
              return (
                item.state === inspectionRecordProcess.sent ||
                item.state === inspectionRecordProcess.pending
              );
            }
          });
          setNotification(filteredData);
        }
      );
    } else {
      callApiAsync(
        () => getDevicesInventoryNotificationsbyUser(userId),
        (data) => {
          const filteredData = data.filter((item) => {
            if (canApproveInspection) {
              if (canEditInspection) {
                return (
                  item.state === inspectionRecordProcess.sent ||
                  item.state === inspectionRecordProcess.pending
                );
              }
              return item.state === inspectionRecordProcess.sent;
            } else {
              return (
                item.state === inspectionRecordProcess.sent ||
                item.state === inspectionRecordProcess.pending
              );
            }
          });
          setNotification(filteredData);
        }
      );
    }
  };

  const handleFilter = () => {
    const newFilters = normalizeFilters(getValuesTable());
    setFilters(newFilters);
    setCurrentPage(1);
    getDevicesInventory(1, rowsPerPage, newFilters);
  };

  const handleClearFilters = () => {
    reset(FILTER_DEFAULTS);
    clearFilters();
    setCurrentPage(1);
    getDevicesInventory(1, rowsPerPage, FILTER_DEFAULTS);
  };

  const handlePageChange = (page, pageSize) => {
    getDevicesInventory(page, pageSize, filters);
  };

  const handleCloseModals = () => {
    setInventaryDownloadModal(false);
    setDetailsModal(false);
    setEditDeviceModal(false);
    setSelectedRow({});
  };

  const getLastUpdate = () => {
    callApiAsync(
      () => biomedicalManagementGetLastUpdate(),
      (data) => {
        setLastUpdatedDate(data.creation_date);
      }
    );
  };

  const formatDate = (date) => {
    if (!date) return "No disponible";
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const columns = [
    {
      field: "serie_id",
      header: "",
      columnType: "hide"
    },
    {
      field: "serie_name",
      header: "Nro. de Serie",
      columnType: "custom-frozen",
      borderRadius: "left",
      render: (rowData) => {
        return (
          <p className="table-default-column w-max-content">
            {rowData.serie_name ? rowData.serie_name : ""}
          </p>
        );
      }
    },
    {
      field: "name",
      header: "Nombre del Equipo",
      columnType: isSmallScreen ? "" : "custom-frozen",
      render: (rowData) => (
        <p className="table-default-column w-130" title={rowData.name || ""}>
          {rowData.name ? rowData.name : ""}
        </p>
      )
    },

    {
      field: "import_date",
      header: "Fecha de importación",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {formatCustomDate(rowData.import_date)}
        </p>
      ),
      columnWidth: "160px"
    },
    {
      field: "manufacturing_date",
      header: "Fecha de fabricación",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {formatCustomDate(rowData.manufacturing_date)}
        </p>
      ),
      columnWidth: "160px"
    },
    {
      field: "rest_useful_life",
      header: (
        <StyledTooltip
          title={
            <>
              <div className="HContainer align-center">
                <div
                  className="color-indicator"
                  style={{ backgroundColor: "#d8f5d1", marginRight: "4px" }}
                />
                <p className="create-label-mini">4 años o más de vida útil</p>
              </div>
              <div className="HContainer align-center">
                <div
                  className="color-indicator"
                  style={{ backgroundColor: "#fff4cc", marginRight: "4px" }}
                />
                <p className="create-label-mini">
                  Entre 2 y 3 años de vida útil
                </p>
              </div>
              <div className="HContainer align-center">
                <div
                  className="color-indicator"
                  style={{ backgroundColor: "#fce4e4", marginRight: "4px" }}
                />
                <p className="create-label-mini">
                  Entre 0 y 1 año de vida útil
                </p>
              </div>
            </>
          }
          placement="top"
        >
          <div className="HContainer ">
            <span className="no-wrap mr-10 ">Vida útil</span>
            <img
              src={icons.infoExclamationWhite}
              alt="info"
              className="btn-icon-table"
            />
          </div>
        </StyledTooltip>
      ),
      columnType: "custom",
      render: (rowData) => {
        const result = getRestUsefulLife(
          getUsefulLifeBaseDate(
            rowData.manufacturing_date,
            rowData.import_date
          ),
          rowData.useful_life
        );
        const status = getUsefulLifeStatus(result?.remainingUsefulLife);
        let fontSize = "10px";

        if (result?.remainingUsefulLife !== undefined) {
          fontSize = "14px";
        }

        return (
          <div className=" j-center">
            <StyledTooltip
                title={
                  <>
                    <p className="create-label">
                      {status.label}
                    </p>
                  </>
                }
            >
              <p
                className="table-default-column pointer"
                style={{
                  backgroundColor: status.bgColor,
                  color: status.textColor,
                  fontSize: fontSize || "10px",
                  borderRadius: "6px",
                  padding: "6px 10px",
                  fontWeight: 600,
                  width: "max-content",
                  textAlign: "center"
                }}
              >
                {result
                  ? `${result.remainingUsefulLife} ${
                      result.remainingUsefulLife === 1 ? "año" : "años"
                    }`
                  : "No disponible"}
              </p>
            </StyledTooltip>
          </div>
        );
      },
      columnWidth: "130px"
    },
    {
      field: "producer_id",
      header: "Nombre de fabricante",
      columnType: "custom",
      render: (rowData) => {
        const producer = producerFilter.find(
          (item) => item.value === rowData.producer_id
        );
        return (
          <StyledTooltip title={<span style={{ color: "#222222" }}>{producer ? producer.name : "Desconocido"}</span>}>
            <p className="table-default-column">
              {producer ? producer.name : "Desconocido"}
            </p>
          </StyledTooltip>
        );
      },
      columnWidth: "210px"
    },
    { field: "institution_id", header: "institution_id", columnType: "hide" },
    { field: "institution_name", header: "Institución" },
    {
      field: "state_id",
      header: "Modalidad",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {getModeText(rowData.state_id, technologyModalityOptions)}
        </p>
      )
    },
    { field: "brand_name", header: "Marca" },
    { field: "brand_id", header: "brand_id", columnType: "hide" },
    { field: "model", header: "Modelo" },
    {
      field: "health_record_or_marketing_permit_text",
      header: "Permiso de Comercialización o Registro Sanitario",
      columnWidth: "300px"
    },

    {
      field: "current_location_id",
      header: "Ubicación id",
      columnType: "hide"
    },
    { field: "current_location_name", header: "Ubicación" },

    { field: "actionButtons", columnType: "actionButtons" }
  ];

  useEffect(() => {
    getFilters();
    getModalityOptions();
    getNotification();
    getDevicesInventory(1, rowsPerPage, filters);
    getLastUpdate();
  }, []);

  const handlePillClick = (comment, biomedical_id) => {
    notificationSetValue("coment", comment);
    setBioEquipmentIdState(biomedical_id);
    setNotificationDataModal(true);
  };

  const handleRedirect = (biomedical_id, inspectionRecordId = null) => {
    dispatch(setBiomedicalId(biomedical_id));
    navigate({
      pathname:
        "/biomedicalManagementDashboard/manageDevice/NewTechnicalInspectionAct",
      search: inspectionRecordId ? `?inspectionRecordId=${inspectionRecordId}` : ""
    });
  };

  const handleNotificationClick = (item) => {
    if (!item?.biomedical_equipment_id) return;

    if (canApproveInspection) {
      handleRedirect(item.biomedical_equipment_id, item.inspectionRecordId);
      return;
    }

    if (item.state === inspectionRecordProcess.pending) {
      handlePillClick(item.comments, item.biomedical_equipment_id);
    }
  };

  const filteredNotifications = notification.filter((item) => {
    if (canApproveInspection) {
      if (canEditInspection) {
        return (
          item.state === inspectionRecordProcess.sent ||
          item.state === inspectionRecordProcess.pending
        );
      }
      return item.state === inspectionRecordProcess.sent;
    } else {
      return (
        item.state === inspectionRecordProcess.sent ||
        item.state === inspectionRecordProcess.pending
      );
    }
  });

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle align-center">
        <Grid justifyContent="space-between" container spacing={1.5}>
          <Grid item xs={12} md={8}>
            <h1>INVENTARIO DE EQUIPOS BIOMÉDICOS</h1>
          </Grid>
          <Grid item xs={12} md={4}>
            <MenuButton
              title="Alertas Acta de Inspección Técnica"
              notification={filteredNotifications.length}
            >
              <p className="not-title">Acta de Inspección Técnica</p>
              {filteredNotifications.map((item) => {
                let statusText = "";
                let statusColor = "";

                switch (item.state) {
                  case 1:
                    statusText = "Rechazado";
                    statusColor = "#F43F5EB8";
                    break;
                  case 2:
                    statusText = canApproveInspection
                      ? "Para Aprobación"
                      : "Esperando Aprobación";
                    statusColor = "#F8A13FA3";
                    break;
                  default:
                    statusText = "Desconocido";
                    statusColor = "gray";
                    break;
                }

                const shouldDisplayItem =
                  item.state !== 0 ||
                  !canApproveInspection;

                if (!shouldDisplayItem) {
                  return null;
                }

                return (
                  <div
                    className="IHContainer j-space-between w-180"
                    key={item.inspectionRecordId || item.name}
                    onClick={() => handleNotificationClick(item)}
                    style={{
                      cursor:
                        canApproveInspection ||
                        item.state === inspectionRecordProcess.pending
                          ? "pointer"
                          : "default",
                      gap: "8px"
                    }}
                  >
                    <p className="not-id-text">{item.name}</p>
                    <div
                      className="pill-layout mt-5 w-75"
                      style={{
                        backgroundColor: statusColor,
                        fontWeight: "bold",
                        cursor:
                          canApproveInspection ||
                          item.state === inspectionRecordProcess.pending
                            ? "pointer"
                            : "default"
                      }}
                    >
                      <p className="not-status-text">{statusText}</p>
                    </div>
                  </div>
                );
              })}
            </MenuButton>
          </Grid>
        </Grid>
      </div>

      <div className="table-container ">
        <div className="IHContainer j-end mt-10">
          <div className="HContainer ">
            {!canImportInventory ? (
              <></>
            ) : (
              <LaddaButton
                variant="contained"
                height={isSmallScreen ? "32px" : "32px"}
                onClick={() => setOpenMasive(true)}
                width={"175px"}
                margin={"0 5px"}
              >
                <div className="IHContainer align-center">
                  <img
                    className="btn-icon"
                    src={icons.upload}
                    alt="icon"
                    style={{ marginRight: "10px" }}
                  />
                  <p className="button_text_mini">Carga Masiva</p>
                </div>
              </LaddaButton>
            )}
            {canDownloadInventory ? (
              <LaddaButton
                variant="contained"
                height={isSmallScreen ? "32px" : "32px"}
                onClick={() => setInventaryDownloadModal(true)}
                width={"175px"}
                margin={"0 5px"}
              >
                <div className="IHContainer align-center">
                  <img
                    className="btn-icon"
                    src={icons.downloadIcon}
                    alt="icon"
                    style={{ marginRight: "10px" }}
                  />
                  <p className="button_text_mini">Descargar inventario</p>
                </div>
              </LaddaButton>
            ) : null}

            {canAccessBiomedicalAdmin ? (
              <LaddaButton
                variant="contained"
                height={isSmallScreen ? "32px" : "32px"}
                onClick={() =>
                  navigate("/biomedicalManagementDashboard/biomedicalAdminPage")
                }
                width={"200px"}
                margin={"0 5px"}
              >
                <div className="IHContainer align-center">
                  <p className="button_text_mini">Administración biomédica</p>
                </div>
              </LaddaButton>
            ) : null}

            {!canEditInventory ? (
              <></>
            ) : (
              <LaddaButton
                variant="contained"
                height={isSmallScreen ? "32px" : "32px"}
                width={"175px"}
                margin={"0"}
              >
                <Link
                  to={{
                    pathname:
                      "/biomedicalManagementDashboard/manageDevice/registerBiomedicalEquipment",
                    state: { newItem: true }
                  }}
                  className="no-underline"
                >
                  <div className="IHContainer align-center">
                    <img
                      className="btn-icon"
                      src={icons.plusIcon}
                      alt="icon"
                      style={{ marginRight: "10px" }}
                    />
                    <p className="button_text_mini white-text">
                      Agregar dispositivo
                    </p>
                  </div>
                </Link>
              </LaddaButton>
            )}
          </div>
        </div>

  <div className="mb-10">
  <form>
    <Grid container rowSpacing={2} columnSpacing={1} alignItems="flex-end" className="biomedical-filters" sx={{ mt: 0 }}>
      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          styledlabel="Equipo"
          name="equipment"
          control={controlTable}
          margin="0"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          styledlabel="Nro de Serie"
          name="serieNumber"
          control={controlTable}
          margin="0"
          marginTop={`${isMediumScreen ? "8px" : null}`}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <MultiSelect
          name="model"
          control={controlTable}
          label="Modelo"
          options={modelFilter}
          margin="0"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <SimpleSelect
          name="usefulLifeStatus"
          control={controlTable}
          label="Estado de Vida Útil"
          options={usefulLifeStatusOptions}
          margin="0"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <MultiSelect
          name="mode"
          control={controlTable}
          label="Modalidad"
          options={technologyModalityOptions}
          margin="0"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <SimpleSelect
          name="brand"
          control={controlTable}
          label="Marca"
          options={brandFilter}
          margin="0"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <MultiSelect
          name="institution"
          control={controlTable}
          label="Institución"
          options={institution}
          margin="0"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <MultiSelect
          name="ubication"
          control={controlTable}
          label="Ubicación"
          options={ubicationFilter}
          margin="0"
        />
      </Grid>

      <Grid item xs={12}>
        <div
          className="IHContainer j-end"
          style={{
            gap: "8px",
            marginTop: "4px"
          }}
        >
          <LaddaButton
            variant="contained"
            onClick={handleFilter}
            margin="0"
            width="52px"
          >
            <img
              className="btn-icon"
              src={icons.filterWhite}
              alt="Filtrar"
            />
          </LaddaButton>

          <LaddaButton
            variant="contained"
            onClick={handleClearFilters}
            margin="0"
            width="52px"
          >
            <img
              className="btn-icon"
              src={icons.clearFilterWhite}
              alt="Limpiar filtros"
            />
          </LaddaButton>
        </div>
      </Grid>
    </Grid>
  </form>
</div>
        <ModalComponent
          open={notificationDataModal}
          handleClose={() => {
            setNotificationDataModal(false);
          }}
          title={""}
          actions={<div className="HContainer j-center w-complete"></div>}
        >
          <Grid container className="mv-25 min-w-700">
            <Grid item xs={12} md={12}>
              <div className="VContainer j-center w-675">
                <p className="text-form-label" style={{ marginLeft: "10px" }}>
                  Comentario:
                </p>
                <FormTextField
                  name="coment"
                  control={notificationControl}
                  isTextArea={true}
                  rows={2}
                  disabled={true}
                />
              </div>
            </Grid>
          </Grid>
          <div className="j-center mt-20">
            <LaddaButton
              width={"110px"}
              fontSize={"12px"}
              height={"32px"}
              variant="contained"
              margin={"0 5px"}
              onClick={() => handleRedirect(bioEquipmentIdState)}
            >
              <div className="j-center">
                <p className="button_text">Modificar</p>
              </div>
            </LaddaButton>
          </div>
        </ModalComponent>

        <div className="IHContainer j-end">
          <p className="bm-last-update">
            Última actualización:{" "}
            <span className="bm-last-update-date">
              {formatCustomDateWithHour(lastUpdatedDate)}
            </span>
          </p>
        </div>

        <div className="biomedical-summary-table">
          <SimpleTable
            tableStyle={{ tableLayout: "fixed", width: "100%", minWidth: "2200px" }}
            loading={loadingTable}
            data={filteredDevices}
            columns={columns}
            text={"Realizar Autoevaluación"}
            isPaginated={true}
            serverPagination={true}
            sortable
            frozen={isSmallScreen ? false : true}
            showItemCount={true}
            totalRecords={totalRecords}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            hidePaginatorRowsDropdown={true}
            buttons={[
              {
                type: "icon",
                icon: canEditInventory ? icons.editYellow : icons.eye,
                onClick: (data) => {
                  setSelectedRow(data);
                  dispatch(setEquipementSerieId(data.serie_id));
                  navigate(
                    `/biomedicalManagementDashboard/manageDevice/registerBiomedicalEquipment`,
                    {
                      state: { deviceData: data }
                    }
                  );
                }
              },
              {
                type: "icon",
                icon: icons.orangeFormGoogle,
                onClick: (data) => {
                  dispatch(setEquipementSerieId(data.serie_id));
                  dispatch(setBiomedicalId(data.id));
                  navigate(
                    `/biomedicalManagementDashboard/manageDevice/BiomedicalEquipmentResume`,
                    {
                      state: { deviceData: data }
                    }
                  );
                }
              },
              {
                type: "icon",
                icon: icons.greengrayLupaGear,
                onClick: (data) => {
                  dispatch(setEquipementSerieId(data.serie_id));
                  dispatch(setBiomedicalId(data.id));
                  navigate(
                    `/biomedicalManagementDashboard/manageDevice/NewTechnicalInspectionAct`,
                    {
                      state: { deviceData: data }
                    }
                  );
                }
              }
            ]}
          />
        </div>
      </div>
      <DeviceDetails
        open={detailsModal}
        handleClose={handleCloseModals}
        data={selectedRow}
      />
      <InventaryDownload
        open={inventaryDownloadModal}
        handleClose={handleCloseModals}
        userId={userId}
        inventoryFilters={buildServerFilters(filters)}
      />
      <EditDevice
        open={editDeviceModal}
        handleClose={handleCloseModals}
        data={selectedRow}
      />

      <MassiveUploadModal
        open={openMasive}
        onClose={() => setOpenMasive(false)}
        title="Carga Masiva de Equipos Biomédicos"
        defaultYear={new Date().getFullYear()}
        onDownloadTemplate={(year) => {
          console.log("[AnyPage] Descargar plantilla año:", year);
        }}
        onFileSelected={(file) => {
          console.log("[AnyPage] Archivo elegido:", file?.name);
        }}
        onUpload={({ file, year }) => {
          console.log("[AnyPage] Subir Carga Masiva", {
            fileName: file?.name,
            year
          });
          setOpenMasive(false);
        }}
      />
    </div>
  );
};

export default ManageDevice;
